import {crmZh} from "../opportunities";
import {commercialPricingZh} from '../commercialPricing';
import { productionMaterialsZh } from '../productionMaterials';
import { executionZh } from '../productionExecution';
import { qualitySpecsZh } from '../qualitySpecs';
import { productionZh } from '../production';
import { dataExportZh } from '../dataExport';
import { docExportZh } from '../documentExport';
import { sourcingZh } from '../sourcing';
import { mrpZh } from '../mrp';
import { unitPricingZh } from '../unitPricing';
import { soZh } from '../salesOrders';
import { previewZh } from '../featurePreview';
import { binsZh } from '../warehouseBins';
import { requisitionsZh } from '../requisitions';
import { routingsZh } from '../routings';
import { bomsZh } from '../boms';
import { transfersZh } from '../transfers';
import { reservationsZh } from '../reservations';
import { stockCountsZh } from '../stockCounts';
import { subcontractZh } from '../subcontract';
import { ncrZh } from '../ncr';
import { salesIssuesZh } from '../salesIssues';
import { ticketsZh } from '../tickets';
import { claimsZh } from '../claims';
import { supplierClaimsZh } from '../supplierClaims';
import { glZh } from '../gl';
import { kpisZh } from '../kpis';
import { userAccessZh } from '../userAccess';
import { pProcessZh } from '../pProcess';
import { redPiZh } from '../redPi';
import { orderProcessZh } from '../orderProcess';
import { portalZh } from '../portal';
import { devicesZh } from '../devices';
import { iqcZh } from "../iqc";
import { warehouseZh } from "../warehouse";
import { releasesZh } from "../releases";
import { settingsWorkspaceZh } from "../settingsWorkspace";
import { userWorkspaceZh } from "../userWorkspace";
import { profitWorkspaceZh } from "../profitWorkspace";
import { statementWorkspaceZh } from "../statementWorkspace";
import { quotationWorkspaceZh } from "../quotationWorkspace";
import { deliveryWorkspaceZh } from "../deliveryWorkspace";
import { packingWorkspaceZh } from "../packingWorkspace";
import { invoiceWorkspaceZh } from "../invoiceWorkspace";
import { piWorkspaceZh } from "../piWorkspace";
import { piPickerZh } from "../piPicker";
import { fxSettingsZh } from "../fxSettings";
import { fxConvertZh } from "../fxConvert";
import { packingBatchZh } from "../packingBatch";
import { evidenceZh } from "../evidence";
import { cardWorkspaceZh } from "../cardWorkspace";
import { sampleWorkspaceZh } from "../sampleWorkspace";
import { poWorkspaceZh } from "../poWorkspace";
import { productListZh } from "../productList";
import { productEditorZh } from "../productEditor";
import { productStockZh } from "../productStock";
import { openingImportZh } from "../openingImport";
import { lotLabelsZh } from "../lotLabels";
import { scanTasksZh } from "../scanTasks";
import { productWorkspaceZh } from "../productWorkspace";
import type { Dict } from "./en";

export const zhHans: Dict = {
  crm:crmZh,
 commercialPricing: commercialPricingZh,
  unitPricing: unitPricingZh,
  mrp: mrpZh,
  productionMaterials: productionMaterialsZh,
  execution: executionZh,
  qualitySpecs: qualitySpecsZh,
  production: productionZh,
  dataExport: dataExportZh,
  docExport: docExportZh,
  sourcing: sourcingZh,
  transfers: transfersZh,
  reservations: reservationsZh,
  stockCounts: stockCountsZh,
  subcontract: subcontractZh,
  ncr: ncrZh,
  salesIssues: salesIssuesZh,
  tickets: ticketsZh,
  claims: claimsZh,
  supplierClaims: supplierClaimsZh,
  gl: glZh,
  kpis: kpisZh,
  userAccess: userAccessZh,
  pProcess: pProcessZh,
  redPi: redPiZh,
  orderProcess: orderProcessZh,
  portal: portalZh,
  devices: devicesZh,
  boms: bomsZh,
  routings: routingsZh,
  requisitions: requisitionsZh,
  so: soZh,
  preview: previewZh,
  bins: binsZh,
  iqc: iqcZh,
  warehouse: warehouseZh,
  releases: releasesZh,
  settingsWorkspace: settingsWorkspaceZh,
  userWorkspace: userWorkspaceZh,
  profitWorkspace: profitWorkspaceZh,
  statementWorkspace: statementWorkspaceZh,
  quotationWorkspace: quotationWorkspaceZh,
  deliveryWorkspace: deliveryWorkspaceZh,
  packingWorkspace: packingWorkspaceZh,
  invoiceWorkspace: invoiceWorkspaceZh,
  piWorkspace: piWorkspaceZh,
  piPicker: piPickerZh,
  fxSettings: fxSettingsZh,
  fxConvert: fxConvertZh,
  packingBatch: packingBatchZh,
  evidence: evidenceZh,
  companySwitch: {
    vn: "越",
    cn: "中",
    label: "公司",
    all: "全部公司",
    hint: "只查看一家公司——所有页面、列表、报表和对账单随之切换。全部即同时查看两家，每条记录标明所属公司。",
    lockedEditing: "请先保存或取消正在编辑的记录，再切换公司。",
  },
  cardWorkspace: cardWorkspaceZh,
  sampleWorkspace: sampleWorkspaceZh,
  poWorkspace: poWorkspaceZh,
  productList: productListZh,
  productEditor: productEditorZh,
  productWorkspace: productWorkspaceZh,
  ...productStockZh,
  ...openingImportZh,
  ...lotLabelsZh,
  ...scanTasksZh,
  brand: { tagline: "贸易 · ERP" },
  trainingEnv: {
    label: "培训环境",
    detail: "示例数据——可放心试用所有功能，不会影响正式系统。",
  },
  piStatus: {
    title: "PI 状态",
    intro: "哪些形式发票需要处理：缺成本、单位混用、采购单仍为草稿或不相符。本页完全不含金额 — 没有营收、成本、毛利或单价，连背后的数据也没有。",
    piNo: "形式发票", customer: "客户", date: "日期", quantity: "数量",
    invoice: "发票", invoiced: "已开发票", notInvoiced: "未开发票",
    costCoverage: "成本覆盖", needsAttention: "待处理", noIssue: "无待处理事项",
    empty: "此期间没有形式发票。", error: "无法加载PI状态。",
    coverage: { po: "来自采购单", mixed: "多重来源", catalog: "来自产品卡", missing: "尚未完整" },
    issues: {
      missing_catalog_cost: "尚无成本", invalid_cost: "成本无效", currency_mismatch: "币种不符",
      unit_mismatch: "单位不符", draft_po: "采购单为草稿", po_charges_excluded: "未计采购运费／税",
      legacy_cost_baseline: "沿用旧系统成本基准",
    },
  },
  priceTiers: {
    title: "数量阶梯价格",
    intro: "依订购数量的售价，对所有客户一致。仅需输入每一阶梯的起始数量 — 下一阶梯会自动封闭上一级。与客户约定的专属价格仍优先于这些阶梯价格，低于MOQ价格另计。",
    fromQuantity: "起始数量", price: "单价（{{currency}}）", range: "{{from}} – {{to}}", andUp: "以上",
    add: "新增阶梯", hintTier: "阶梯自{{from}}", hintUnderMoq: "低于MOQ价格", hintCustomer: "此客户专属价", hintApply: "点击采用此价格", empty: "尚无阶梯价格 — 使用产品卡上的售价。",
    invalid: "请输入1以上的整数起始数量与有效单价。",
    duplicate: "两个阶梯不可从相同数量开始。",
    error: "无法加载或保存阶梯价格。",
  },
  mail: {
    title: "通过电子邮件发送", from: "发件人", to: "收件人", toPlaceholder: "customer@example.com",
    subjectLabel: "主题", body: "内容", send: "发送", noMailbox: "尚未设置邮箱",
    notConfigured: "尚未设置发件邮箱，因此无法发送。下方草稿已准备好 — 完成邮箱设置后即可在此发送。",
    error: "无法发送邮件。",
    greeting: "{{customer}} 您好，", closing: "敬祝 商祺",
    subject: { pi: "形式发票 {{documentNo}}", sampleOrder: "样品订单 {{documentNo}}" },
    intro: { pi: "谨附上形式发票 {{documentNo}} 的内容如下。", sampleOrder: "谨附上样品订单 {{documentNo}} 的内容如下。" },
    line: { date: "日期：{{date}}", customerPo: "贵司订单号：{{po}}", products: "品项：{{codes}}" },
  },
  productFiles: {
    title: "产品文件（仅限管理员）",
    intro: "图片文件、技术PDF、Office文件与压缩文件，每个文件最大 {{max}}。大型文件会在浏览器端切割并分段通过本站上传，因此CAD文件用一般网络也能上传。仅管理员可上传与下载 — 目录图与批准图不受影响。",
    choose: "选择文件", uploading: "上传中…", empty: "尚无文件。",
    progress: "{{name}} · 第 {{done}}/{{total}} 段",
    error: "无法加载、上传或删除文件。",
    reject: { empty_name: "文件没有名称。", too_large: "文件需在 {{max}} 以内。", blocked_type: "不接受打开后可执行的文件（exe、js、html、svg…）。" },
  },
  nav: {
    opportunities: "销售机会",
    sourcing: "RFQ与供应商报价",
    mrp: "物料需求计划（MRP）",
    unitPricing: "单位与价格设置",
    pendingReview: "待客户确认",
    walkthroughDone: "已与负责人审阅 {{date}}",
    overview: "总览与报表",
    dashboard: "仪表盘",
    analytics: "销售分析",
    profit: "利润汇总",
    piStatus: "PI 状态",
    kpis: "运营KPI",
    orderProcess: "常规流程",
    pProcess: "P 流程",
    portal: "供应商门户",
    devices: "扫描与标签",
    masterData: "主数据",
    products: "产品",
    customers: "客户",
    customerTerms: "付款条款与订单要求",
    suppliers: "供应商",
    sales: "销售",
    proformaInvoices: "形式发票 (PI)",
    redPi: "Red PI",
    invoices: "发票",
    quotations: "报价单",
    packingLists: "装箱单",
    deliveryNotes: "送货单",
    statement: "对账单 (应收)",
    procurement: "采购",
    purchaseOrders: "采购单",
    supplierClaims: "供应商索偿",
    samples: "样品",
    sampleOrders: "样品订单",
    sampleCards: "样品卡",
    erp: "ERP 模块",
    warehouse: "仓库与批次",
    warehouseLocations: "库位",
    production: "生产",
    quality: "质量",
    finance: "会计分录",
    admin: "系统管理",
    settings: "设置",
    users: "用户管理",
    deletedRecords: "已删除记录",
    routings: "工艺路线",
    boms: "物料清单 (BOM)",
    salesOrders: "销售订单",
    requisitions: "采购申请",
    stockMoves: "库存变动",
    glAccounts: "会计科目",
    serviceTickets: "售后服务",
    inventoryDelivery: "库存与出货",
    manufacturingQuality: "生产与质量",
    financeReceivables: "财务与应收账款",
    inDevelopment: "开发中",
    inProgress: "开发中",
  },
  common: {
    internalReference: "内部订单",
    internalReferenceHint: "此单据属于您无权查看的客户——仓库与生产仍照常处理该订单，只是不显示单号与客户名称。",
    internalSupplier: "内部供应商",
    internalSupplierHint: "此为您无权查看的私密供应商——单据仍会显示以便仓库作业，但只有管理员和该供应商的跟进人能看到名称并修改。",
    printLanguage: "打印语言",
    printLanguage_en: "英文",
    printLanguage_zh: "中文",
    labelLanguage: "标签语言",
    labelLanguage_en: "英文",
    labelLanguage_zh: "中文",
    labelLanguage_both: "中英文",
    labelLanguageHint: "打印时选择，适用于本次打印的所有标签。选择会保存在此设备上。",
    descriptionLangHint: "下方描述栏目前编辑的是{{lang}}版本。切换上方按钮可编辑并打印另一版本。",
    rowNumber: "序号",
    search: "搜索",
    typeToSearch: "输入几个字以搜索…",
    searchPlaceholder: "搜索单据、客户、产品…",
    new: "新增",
    create: "创建",
    export: "导出",
    print: "打印",
    filter: "筛选",
    all: "全部",
    cancel: "取消",
    continue: "继续",
    close: "关闭",
    save: "保存",
    edit: "编辑",
    actions: "操作",
    language: "语言",
    webVersion: "v{{version}}",
    signOut: "退出登录",
    viewAll: "查看全部",
    noDocuments: "尚无单据。",
    documentsError: "无法加载单据。",
    removeFilter: "移除筛选",
    soon: "即将推出",
    loading: "加载中…",
    /** Mảnh cuối của thanh đường dẫn khi chứng từ không mở được (ngoài phạm vi, đã xoá, lỗi mạng) — thay "Đang tải…". */
    unavailable: "无法打开",
    savedShort: "已保存",
    saving: "保存中…",
    creating: "创建中…",
    uploading: "上传中…",
    retry: "再试一次",
    delete: "删除",
    confirmArchive: "此记录将被归档，日后可还原。",
    refresh: "刷新",
    remove: "移除",
    restore: "还原",
    add: "新增",
    addLine: "新增项目",
    removeLine: "移除项目",
    removeContact: "移除联系人",
    deletePayment: "删除付款记录",
    noMatches: "找不到相符结果",
    editMode: "编辑",
    createMode: "创建",
    saved: "已保存。",
    unsavedTitle: "放弃未保存的变更？",
    unsavedDescription: "变更尚未保存。若现在关闭，这些变更将会丢失。",
    keepEditing: "继续编辑",
    discardChanges: "放弃变更",
    openNavigation: "打开导航",
    closeNavigation: "关闭导航",
    toggleSidebar: "收起或展开侧边栏",
    primaryNavigation: "主导航",
    breadcrumb: "面包屑导航",
    name: "名称",
    email: "邮箱",
    password: "密码",
    role: "角色",
    status: "状态",
    date: "日期",
    type: "类型",
    total: "总计",
    product: "产品",
    customer: "客户",
    supplier: "供应商",
    items: "项目",
    remarks: "备注",
    code: "编号",
    description: "说明",
    color: "颜色",
    size: "尺寸",
    colorSize: "颜色 / 尺寸",
    quantity: "数量",
    qty: "数量",
    unitPrice: "单价",
    amount: "金额",
    subtotal: "小计",
    delivery: "交货",
    shipping: "运送",
    method: "方式",
    address: "地址",
    phone: "电话",
    taxId: "税务编号",
    reference: "参考",
    fromPi: "来源 PI",
    shipTo: "送货至",
    cartons: "箱数",
    when: "时间",
    age: "账龄",
    version: "版本",
    location: "位置",
    result: "结果",
    rejected: "拒绝",
    planned: "计划",
    produced: "已生产",
    priority: "优先级",
    subject: "主题",
    lastLogin: "上次登录",
    originalId: "原始 ID",
    deletedBy: "删除者",
    currency: "币种",
    created: "创建 / 人",
    createdOn: "创建日期",
    yes: "是",
    no: "否",
    createdBy: "创建人",
    createdDate: "创建日期",
    invalidField: "数值无效：{{field}}",
    lineError: "第 {{line}} 行：{{field}}无效",
    subRef: "子参考",
    customerStyleNo: "客户款号",
    unit: "单位",
    moq: "最小订货量",
    mcq: "MCQ",
    msq: "MSQ",
    dtdPrice: "DTD 价",
    exwPrice: "EXW 价",
    underMoqPrice: "低于 MOQ 价",
    sampleLeadTime: "样品交期",
    bulkLeadTime: "量产交期",
    image: "图片",
    lineRemark: "明细备注",
    currencyLabel: "币种",
  },
  pagination: {
    label: "分页",
    range: "第 {{from}}–{{to}} 项，共 {{total}} 项",
    rowsPerPage: "每页行数",
    pageOf: "第 {{page}} / {{pages}} 页",
    first: "第一页",
    previous: "上一页",
    next: "下一页",
    last: "最后一页",
    goToPage: "前往第",
  },
  login: {
    supplierHint: "使用 Hisense 提供的供应商代码与密码。",
    title: "登录",
    brandLogoAlt: "Hisense Button 标志",
    subtitle: "Hisense Button · 管理系统",
    heroEyebrow: "贸易与制造 ERP",
    heroTitle: "一体化运营平台，贯通销售与生产。",
    heroDescription:
      "将销售、单据、样品管理及工厂运营整合于同一多语言系统，支持越南与中国团队协作。",
    heroModules: "8 个 ERP 模块",
    heroLanguages: "VI · EN · 中文",
    heroCloud: "连接越南与中国",
    builtBy: "解决方案由 ToanKhonTech 开发",
    email: "邮箱",
    emailPlaceholder: "email@hisensebutton.com",
    audienceLabel: "选择登录入口",
    audienceStaff: "Hisense 员工",
    audienceSupplier: "供应商",
    supplierId: "供应商代码",
    supplierIdPlaceholder: "NCC-XXXXXX",
    staffHint: "使用 Hisense 员工邮箱与密码登录。",
    wrongTabStaff: "这看起来像供应商代码，请改选上方“供应商”。",
    wrongTabSupplier: "这看起来像邮箱地址，请改选上方“Hisense 员工”。",
    password: "密码",
    showPassword: "显示密码",
    hidePassword: "隐藏密码",
    remember: "保持登录",
    submit: "登录",
    submitting: "正在登录…",
    demoLabel: "演示账户",
    errorInvalidCredentials: "邮箱或密码不正确。",
    errorAccountDisabled: "此账户已停用，请联系系统管理员。",
    errorGeneric: "登录失败，请再试一次。",
  },
  dashboard: {
    activity: {
      pi_created: "创建形式发票 · {{amount}}",
      invoice_created: "创建发票 · {{amount}}",
      quotation_created: "创建报价单",
      po_created: "创建采购单 · {{amount}}",
    },
    title: "仪表盘",
    subtitle: "运营一览",
    revenueMTD: "营收 · 本月",
    openPis: "未结形式发票",
    arOutstanding: "应收账款",
    arOverdue: "逾期",
    samples: "进行中样品",
    noReorderPoint: "{{count}} 项产品尚未设置再订购点",
    inventory: {
      title: "仓库待处理",
      since: "（自 {{since}} 起，首张期初库存过账日）",
      deliveredNotIssued: "已离仓但未记录货源，或客户收货多于出库数量的送货单",
      invoicesFromStock: "销售有库存品项但尚无记录货源之送货单的发票",
      receivedNotStocked: "标记为已到货但未足额入库的采购单",
      directWithStock: "有库存时仍直送——待审核者查看",
      clear: "仓库：无待处理事项（自 {{since}} 起）。",
      notStarted: "尚未开始按批次管理库存：尚无期初库存过账。",
      openCounts: "输入期初库存",
    },
    activity7d: "近 7 天创建的单据",
    work: {
      unpaidPis: "尚未收足款的形式发票",
      expiredPis: "已过有效期",
      openPos: "尚未全数交货的采购单",
      openQuotations: "报价单",
    },
    lowStock: "低库存产品",
    recentActivity: "近期活动",
    arAging: "应收账龄",
    topCustomers: "主要客户 · 未结应收",
    awaiting: "待收款",
    changeVsLastMonth: "{{value}}% 与上月相比",
    noPrevMonth: "上月无营收可比较",
    currencyExcluded: "未包含 {{count}} 张 {{currency}} 单据",
    errorLoad: "无法加载仪表盘。",
    paymentActivity: "已记录 {{method}} 付款 {{amount}}",
    paymentMethod: "付款",
  },
  customers: {
    /** Dấu nối tên người theo đơn — tiếng Hoa dùng "、". */
    followersSeparator: "、",
    followersLine: "跟单员：{{names}}",
    /** Khách riêng tư / liên hệ riêng tư (Roary 30/09/2026) — chỉ quản trị viên thấy và đặt được. */
    private: "私密客户",
    privateHint: "只有管理员能看到此客户及其所有单据（报价单、PI、发票、装箱单、送货单、样品订单、对账单、报表）。跟单员、财务和仓库人员也看不到。",
    followersPrivate: "私密客户：非管理员的跟单员将看不到此客户。",
    privateBadge: "私密",
    contactPrivate: "仅管理员可见",
    contactPrivateToggle: "仅管理员可见 · 联系人 {{n}}",
    contactsPrivateHint: "点击姓名栏中的锁形图标，即可设为只有管理员能看到该联系人（例如客户的老板）。其他用户在客户资料、搜索和收件人选择中都看不到该联系人；他们保存客户资料也不会删除该联系人。",
    privateContactSuffix: "（仅管理员）",
    followerAdd: "添加跟单员…",
    followerRemove: "移除 {{name}}",
    followerOptionsError: "无法加载员工列表。",
    followerUnreachable: "{{names}}：无法查看此客户（不同区域或账号已停用），建议移除。",
    followerSelfLocked: "您只能查看自己跟单的客户，因此您的名字会一直保留。",
    followersHint: "可选择多人。仅限自己跟单客户的账号，只有名列此处才能看到此客户。",
    followersNone: "尚未指定跟单员——只有管理员和可查看所有客户的账号能看到此客户。",
    followerDisabled: "已停用",
    filterNoFollower: "未指定跟单员",
    code: "客户代码 / 简称",
    codeHint: "内部识别代码，不可重复。选填。",
    codeTaken: "此代码已被其他客户使用。",
    filterPrivate: "私密客户",
    filterPrivateHint: "只显示私密客户（仅管理员可见）。可与越南 / 中国同时使用——私密客户仍归属其原公司。",
    editCustomer: "编辑客户",
    editNamed: "编辑客户：{{name}}",
    backToList: "返回客户列表",
    required: "必填",
    sectionSales: "销售设置",
    moreContacts: "另有 {{count}} 位联系人",
    errorDelete: "无法删除客户。",
    notFound: "找不到此客户。",
    title: "客户",
    subtitle: "主数据 · 客户与联系人",
    company: "公司",
    classification: "类别",
    vietnam: "越南",
    china: "中国",
    classificationLocked: "已固定为您账号的数据区域。",
    cs: "跟单员",
    terms: "付款条件",
    contacts: "联系人",
    contactCount: "联系人数",
    openAr: "未结应收",
    newCustomer: "新增客户",
    loading: "正在加载客户…",
    errorLoad: "无法加载客户列表。",
    errorSave: "无法保存客户。",
    confirmDeleteNamed: "要删除 {{name}} 吗？记录将移至归档。",
    addContact: "新增联系人",
    contactName: "联系人姓名",
    contactPersonN: "联系人 {{n}}",
    phone1: "电话 1",
    phone2: "电话 2",
    wechat: "微信号",
    section: "部门",
    brandName: "品牌",
    team: "团队",
    contactsCountHint: "{{count}} / {{max}} 位联系人 · 每位须填姓名",
    errorContactName: "联系人 {{n}}：必须填写姓名。",
    selectTerm: "选择付款条件",
    unassigned: "未指派",
    sectionCompany: "公司信息",
    sectionContacts: "联系人",
    companyHint: "打印于单据上的名称、地址与电话。",
    salesHint: "付款条件、类别、跟单员，以及新 PI 的 P-Process 默认设置。",
    saveHint: "完全空白的联系人行会在保存时跳过。",
    sideShow: "显示其他字段",
    sideHide: "隐藏其他字段",
    sideColumns: "电话 2、品牌、微信号、团队",
    sideLocked: "有联系人使用其他字段，因此会一直显示。",
    piRef: "PI {{no}}",
    documents: "近期单据",
    documentsHint: "每类显示最新 5 条。点“查看全部”打开已依此客户筛选的列表。",
    itemCount: "{{count}} 个品项",
    noContacts: "尚无联系人",
    openCustomer: "打开客户",
  },
  lot: {
    pProcessDefaultOff: "新形式发票默认停用",
    pProcessDefaultOn: "新形式发票默认启用",
    number: "批号",
    placeholder: "供应商批号",
    pProcess: "P-Process",
    pProcessHint: "此订单的所有单据都追踪批号",
    pProcessDefault: "默认启用 P-Process",
    pProcessDefaultHint: "设置新形式发票的默认 P-Process 模式，已创建的单据保留各自的设置。LOT 号码依各明细行输入，使用供应商的批次号码。",
  },
  products: {
    title: "产品",
    refs: "子参考 / 客户编号",
    typeBrand: "类型 / 品牌",
    wireSize: "线径尺寸",
    weightPer100: "每100重量",
    lowestPrice: "最低价",
    upCharge: "加收",
    leadTime: "交期 样/量",
    orderQty: "MOQ / MCQ·MSQ",
    storageLocation: "仓库 / 位置",
    currency: "币种",
    created: "创建 / 人",
    subtitle: "主数据 · 目录与定价",
    searchPlaceholder: "搜索编号、描述、编号参照、品牌、颜色…",
    allTypes: "全部类型",
    allBrands: "全部品牌",
    allApprovals: "全部审批",
    allSuppliers: "全部供应商",
    filterSearch: "筛选列表…",
    code: "编号",
    description: "描述",
    descriptionEn: "英文描述",
    descriptionZh: "中文描述",
    descriptionPrimary: "设为主要",
    descriptionHint: "主要描述会带入单据品项并印在标签上。单据以何种语言打印，于该单据上另行选择，因为同一款产品可能卖给阅读不同语言的客户。若其中一栏留空，系统会改用另一栏，而不会印出空白。",
    type: "类型",
    selectType: "选择产品类型",
    legacyType: "目前的旧值",
    brand: "品牌",
    color: "颜色",
    size: "尺寸",
    colorZh: "颜色（中文）",
    materialType: "材料类型",
    materialTypeHint: "例如：黄铜、304 不锈钢、锌合金",
    materialWidth: "材料宽度",
    materialThickness: "厚度",
    materialHardness: "硬度 / 状态",
    materialHardnessHint: "例如：H14、1/2H、HV 150",
    unit: "单位",
    selectUnit: "选择产品单位",
    legacyUnit: "目前的旧值",
    moq: "最小订货量",
    stock: "库存",
    approval: "审批",
    sellingPrice: "售价",
    sellingPriceHint: "默认牌价 · {{currency}}",
    costPrice: "成本",
    supplier: "供应商",
    supplierAndRef: "供应商 / 编号",
    newSampleOrderFrom: "以此产品创建样品订单",
    newSampleCardFrom: "以此产品创建样品卡",
    advancedFilters: "高级筛选",
    clearFilters: "清除筛选",
    minPrice: "售价下限",
    maxPrice: "售价上限",
    minStock: "库存下限",
    maxStock: "库存上限",
    createdFrom: "创建起始日",
    createdTo: "创建截止日",
    rangeReversed: "起始值大于结束值，不会有任何结果。",
    newProduct: "新增产品",
    codeHint: "留空 = 自动编号",
    image: "图片",
    imagePreview: "产品图片",
    viewImage: "查看图片",
    uploadImage: "上传图片",
    removeImage: "移除",
    imageDropHint: "拖入或粘贴图片",
    imageDropTitle: "点击选择图片，或把图片拖到这里，或按 {{shortcut}} 粘贴已复制的图片（例如微信图片）。",
    imageDropNoFile: "没有收到图片文件。请复制图片（例如在微信中）后在此按 {{shortcut}}，或先保存图片再点击“上传图片”。",
    invalidNumber: "数字格式无效",
    confirmDelete: "删除此产品？将被归档，日后可还原。",
    loading: "正在加载产品…",
    errorLoad: "无法加载产品列表。",
    errorSave: "无法保存产品。",
    imageTooLarge: "图片须在 5MB 以内（以压缩后计算）。",
    imageBadType: "仅接受 PNG、JPEG、WEBP 或 GIF 图片。",
    legacyNegative: "旧数据：{{fields}} 为负值，本表单不接受。请先修正或清空这些字段再保存。",
    errorUpload: "图片上传失败。",
    subRef: "子参考",
    subRefHint: "选填的变体编号（颜色、尺寸…）",
    customerRef: "客户编号",
    supplierProductRef: "供应商产品编号",
    selectSupplier: "选择供应商",
    currencyLabel: "币种",
    lowestPriceHint: "可接受的最低售价",
    sampleLeadTime: "样品交期（天）",
    bulkLeadTime: "量产交期（天）",
    moqHint: "总最少订购量",
    mcq: "MCQ",
    mcqHint: "每色最少数量",
    msq: "MSQ",
    msqHint: "每尺寸最少数量",
    storage: "仓库",
    moldRef: "模具编号",
    moldLocation: "模具存放位置",
    wire: {
      length: "长度",
      width: "宽度",
      height: "高度",
      innerWidth: "内宽",
      diameter: "直径",
      wireDiameter: "线径",
    },
    reorderPoint: "再订购点",
    reorderPointHint: "库存低于此值时提醒。留空则不提醒 — 这不是 MOQ。",
    storageHint: "仓储类型或条件",
    weightUnit: "重量单位",
    wireLength: "长度",
    wireWidth: "宽度",
    wireHeight: "高度",
    wireInnerWidth: "内宽",
    wireDiameter: "直径",
    wireWireDiameter: "线径",
    approvalProof: "审批证明",
    approvalProofHint: "审批函、电子邮件或证书（选填）",
    uploadApprovalProof: "上传证明",
    removeApprovalProof: "移除证明",
    keepOpenNextCode: "保存后保持打开并带入下一个编号",
    sectionBasic: "基本信息",
    sectionSpecs: "规格",
    sectionSupplier: "供应商",
    sectionPricing: "价格与交期",
    sectionStatus: "状态与库存",
    filterType: "所有类型",
    openProduct: "查看产品详情",
    notFound: "找不到产品。",
    errorDelete: "无法删除此产品。",
  },
  pricing: {
    title: "客户专属价",
    hint: "此价格只覆盖单一客户的售价。其他客户使用上方售价。",
    customer: "客户",
    selectCustomer: "选择客户",
    scope: "适用于",
    listPrice: "标准价",
    price: "价格",
    setPrice: "设置客户价",
    effective: "生效",
    status: "状态",
    current: "现行",
    closed: "已结束",
    none: "尚无客户专属价。单据使用上方售价。",
    afterSave: "请先保存产品，再打开以新增客户价。",
    invalidPrice: "请输入有效价格",
    errorSet: "无法设置价格。",
    loading: "正在加载价格…",
  },
  quotations: {
    no: "报价编号",
    new: "新增报价",
    preparedBy: "制表人",
    lines: "明细",
    subtitle: "独立报价单",
    document: "报价单",
    to: "致",
    attn: "收件人",
    errorLoad: "无法加载报价单列表。",
    errorSave: "无法保存报价单。",
    confirmDelete: "要删除报价单 {{number}} 吗？",
    printingDate: "打印日期",
    billToText: "抬头（自定义文字）",
    billToTextHint: "沿用自旧系统；请在上方选择客户。",
    unknownCustomer: "未知客户（打印时隐藏）",
    addProduct: "新增产品",
    duplicateProduct: "该产品已在此报价单中。",
  },
  samples: {
    courier: "快递公司",
    trackingNo: "运单号",
    shippedAt: "寄出日期",
    newOrder: "新增样品订单",
    newCard: "新增样品卡",
    orderType: "订单类型",
    team: "部门",
    labTest: "检测要求",
    ordersSubtitle: "样品开发 · 实验室测试",
    cardsSubtitle: "参考样品卡",
    fromSupplier: "来自供应商",
    toCustomer: "送往客户",
    productNo: "产品编号",
    requestedShort: "要求",
    retainedShort: "留样",
    orderNo: "样品单号",
    party: "往来方",
    cardNo: "样品卡号",
    errorOrders: "无法加载样品订单。",
    errorCards: "无法加载样品卡。",
    errorCreateOrder: "无法创建样品订单。",
    errorCreateCard: "无法创建样品卡。",
    errorUpload: "图片上传失败。",
    orderDelivery: "订单日 / 交期",
    attachments: "附件",
    firstProduct: "产品",
    andMore: "另 {{count}} 项",
    contactEmail: "联系邮箱",
    contactHint: "创建订单时锁定，重印时与发出版本一致。",
    controlSample: "封样",
    productDesc: "产品 / 描述",
    orderDate: "订单日期",
    deliveryDate: "交货日期",
    editOrder: "编辑样品订单",
    editCard: "编辑样品卡",
    selectSupplier: "搜索并选择供应商",
    selectCustomer: "搜索并选择客户",
    contactPerson: "联系人",
    selectContact: "选择联系人",
    addProduct: "新增产品",
    manualEntry: "手动输入",
    manualBadge: "手动",
    searchProducts: "依编号、描述、类型或品牌搜索…",
    duplicateProduct: "此产品已在订单中。",
    subRef: "子参考",
    requestQuantity: "要求数量",
    retainedQuantity: "留样数量",
    controlSampleNotes: "封样备注",
    useProductImage: "使用产品图片",
    noItems: "尚未新增产品",
    noItemsHint: "使用“新增产品”从目录选取，或用“手动输入”新增尚未建档的产品。",
    addFiles: "新增文件",
    noAttachments: "尚无附件",
    attachmentHint: "图片（JPG、PNG、WebP，最大 5 MB）或文件（PDF、DOC、XLS、PPT，最大 10 MB）",
    attachmentCount: "{{count}} / {{max}}",
    attachmentSizeKb: "{{size}} KB",
    deleteAttachment: "删除附件",
    selectLabTest: "选择检测标准",
    labTestHint: "此样品所需的检测标准。",
    orderRemarks: "订单备注",
    printDevSheet: "打印开发单",
    devSheetTitle: "开发单",
    skippedExisting: "跳过 {{count}} 个目录中已有的编号：{{codes}}。",
    skippedIncomplete: "跳过 {{count}} 行缺少描述或类型：{{codes}}。",
    addToProductsFailed: "无法将这些明细加入产品目录。",
    addToProducts: "加入产品资料",
    addedToProducts: "已将 {{count}} 个产品加入目录。",
    alreadyInProducts: "此产品编号已存在于目录中。",
    confirmDeleteOrder: "删除此样品订单？系统会归档，日后可还原。",
    confirmDeleteCard: "删除此样品卡？系统会归档，日后可还原。",
    errorSaveOrder: "无法保存样品订单。",
    errorSaveCard: "无法保存样品卡。",
    loadingOrder: "正在加载样品订单…",
    productNoRequired: "必须填写产品编号。",
    typeRequired: "必须选择类型。",
    descriptionRequired: "必须填写描述。",
    document: "样品订单",
    orderInfo: "订单信息",
    supplierInfo: "供应商信息",
    orderDetails: "订单明细",
    contactPhone: "联系电话",
    autoNumberHint: "保存时自动编号",
    supplierRequired: "必须选择供应商。",
    itemsRequired: "至少需要一项产品。",
    deliveryDateRequired: "必须填写交货日期。",
    teamRequired: "必须填写部门。",
    duplicateProductNo: "此产品编号已在订单中。",
    changeStatus: "变更状态",
    deleteOrder: "删除样品订单",
    deleteCard: "删除样品卡",
    openAttachment: "打开附件",
    uploadInProgress: "请等待上传完成后再保存。",
    unsavedUploadsDescription: "此样品订单有未保存的变更，包含已上传的文件。现在离开将会丢失。",
    loadingCard: "正在加载样品卡…",
  },
  suppliers: {
    classification: "区域",
    classificationHint: "使用此供应商的团队。两个团队向同一家工厂采购时，各自保留一份供应商资料。",
    classificationChoose: "选择团队",
    classificationLocked: "您的账号只处理一个区域，因此不能更改供应商的区域。",
    unclassified: "未分类",
    unclassifiedHint: "未分类：在选定团队之前，两个团队都能看到此供应商。",
    sectionAccess: "查看权限",
    accessHint: "由谁跟进此供应商，以及是否只限部分人员查看。",
    followers: "跟进人",
    followerAdd: "添加跟进人…",
    followersHint: "负责此供应商的员工。普通供应商仍对整个团队可见。",
    followersPrivateHint: "私密供应商：只有管理员和这些人能看到档案。也可在设置 → 用户 → 权限中选择——两处是同一份名单。",
    followersNone: "暂无跟进人。",
    adminOnly: "只有管理员能更改跟进人或设为私密供应商。",
    private: "私密供应商",
    privateHint: "只有管理员和跟进人能看到档案、联系人以及产品上的成本价。其他人仍能看到该供应商的采购订单、入库单和应付款，但名称显示为「内部供应商」且无法修改。",
    privateBadge: "私密",
    contactPrivate: "仅管理员可见",
    contactPrivateToggle: "仅管理员可见 · 联系人 {{n}}",
    vietnam: "越南",
    china: "中国",
    portalLoginId: "供应商门户登录代码",
    portalLoginHint: "此代码交给供应商：它是登录名称而非机密，密码才是身份证明。不区分大小写。",
    portalLoginGenerate: "生成代码",
    portalSection: "供应商门户",
    portalIntro: "供应商以下方代码与您在此设置的密码登录。账号、密码与锁定／解锁都在此面板管理。",
    portalAfterSave: "请先保存供应商，再于编辑页开通门户。",
    portalNoAccount: "尚未开通",
    portalStatusActive: "已开通",
    portalStatusDisabled: "已锁定",
    portalPassword: "初始密码",
    portalNewPassword: "新密码",
    portalPasswordConfirm: "再次输入密码",
    portalPasswordHint: "至少 8 个字符。连同代码交给供应商；首次登录时必须更改。系统不会再次显示密码。",
    portalOpen: "开通门户",
    portalOpened: "已开通。请将代码与密码传给供应商。",
    portalSaveLoginId: "保存代码",
    portalLoginIdSaved: "登录代码已更改，旧代码不再有效。",
    portalMustChange: "仍为初始密码：供应商尚未登录并自行更改。",
    portalPasswordChanged: "供应商已自行更改密码。",
    portalLastLogin: "最近登录：{{when}}",
    portalNeverLoggedIn: "从未登录。",
    portalResetPassword: "重置密码",
    portalResetDone: "密码已重置。供应商下次登录时必须再次更改。",
    portalDisable: "锁定门户",
    portalEnable: "解除锁定",
    portalDisabled: "已锁定。解除锁定前供应商无法登录。",
    portalEnabled: "门户已解除锁定。",
    portalError: "无法更新门户账号。",
    companyContact: "公司联系方式",
    editSupplier: "编辑供应商",
    editNamed: "编辑供应商：{{name}}",
    backToList: "返回供应商列表",
    required: "必填",
    title: "供应商",
    subtitle: "主数据 · 供应商与联系人",
    company: "公司",
    address: "地址",
    phone: "电话",
    email: "邮箱",
    contacts: "联系人",
    contactCount: "联系人数",
    moreContacts: "另有 {{count}} 人",
    newSupplier: "新增供应商",
    addContact: "新增联系人",
    contactName: "联系人姓名",
    contactCard: "联系人 {{n}}",
    specialization: "专长",
    confirmDelete: "删除此供应商？将被归档，日后可还原。",
    loading: "正在加载供应商…",
    errorLoad: "无法加载供应商列表。",
    errorSave: "无法保存供应商。",
    phone1: "电话 1",
    phone2: "电话 2",
    wechat: "微信号",
    selectSpecialization: "选择专长",
    openSupplier: "查看供应商详情",
    notFound: "找不到供应商。",
    errorDelete: "无法删除此供应商。",
    sectionCompany: "公司",
    companyHint: "打印于采购单据上的名称、地址、电话与邮箱。",
    contactsCountHint: "{{count}}/{{max}} 位联系人 · 每位联系人都必须有姓名",
    saveHint: "完全空白的联系人行会在保存时忽略。",
    sideShow: "显示其他字段",
    sideHide: "隐藏其他字段",
    sideColumns: "电话 2、微信号",
    sideLocked: "有联系人使用其他字段，因此会一直显示。",
    noContacts: "此供应商尚无联系人。",
    viewProducts: "查看产品",
    documents: "近期单据",
    documentsHint: "每类显示最新 5 条。点“查看全部”打开已依此供应商筛选的列表。",
    contactsCount: "联系人 · {{count}}",
  },
  pi: {
    title: "形式发票 (PI)",
    subtitle: "销售源头单据 · 付款明细账",
    piNo: "PI 编号",
    date: "日期",
    billTo: "付款方",
    poNo: "客户 PO",
    total: "总计",
    paid: "已付",
    balance: "余额",
    status: "状态",
    respBy: "负责人",
    billToContact: "付款方 / 联系人",
    notifyParty: "通知方 / 联系人",
    consignee: "收货人 / 联系人",
    paymentCompany: "收款公司",
    invoiceStatus: "发票",
    notInvoiced: "未开立发票",
    newPi: "新增 PI",
    lineItems: "明细项目",
    receivableTitle: "各发票已付金额",
    stillOwed: "尚欠",
    unapplied: "已收款但尚未核销任何发票",
    payments: "付款",
    item: "项目",
    description: "描述",
    qty: "数量",
    exwTag: "EXW",
    exwUsedOnPrint: "此行以 EXW 价打印。",
    unitPrice: "单价",
    amount: "金额",
    noPayments: "尚未记录付款。",
    recordPayment: "记录付款",
    convertInvoice: "创建发票",
    createPacking: "创建装箱单",
    createPo: "创建采购单",
    document: "形式发票",
    invoiced: "已开立发票",
    delivery: "交货",
    shipping: "运送",
    method: "方式",
    subtotal: "小计",
    linesCount: "{{count}} 个项目",
    errorLoad: "无法加载此形式发票。",
    errorList: "无法加载形式发票列表。",
    errorCreateInvoice: "无法创建发票。",
    errorRecordPayment: "无法记录付款。",
    validAmount: "请输入有效金额。",
    adminOnly: "仅限管理员",
    adminOnlyHint: "只有管理员账号能看到此形式发票及其衍生的所有单据。设置后无法取消。",
    adminOnlyAdminsOnly: "只有管理员可以将形式发票设为“仅管理员可见”。",
    amendReason: "修改已开立发票的形式发票的原因",
    amendReasonHint: "此形式发票已开立发票。仍可修改，但必须填写原因（至少5个字符），原因会保存于单据历史。修改后，于发票中重新选取此形式发票即可带入新价格，发票号码不变。一旦已有送货单则不得再修改。",
    confirmDelete: "要删除 PI {{number}} 吗？记录将移至归档。",
    errorSave: "无法保存形式发票。",
    openBalance: "未清余额",
    contactPerson: "联系人",
    billToContactPerson: "付款方（联系人）",
    notifyPartyCustomer: "通知方",
    notifyPartyContactPerson: "通知方（联系人）",
    consigneeCustomer: "收货人",
    consigneeContactPerson: "收货人（联系人）",
    shippingMarks: "唛头",
    customerDept: "客户部门",
    portOfLoading: "装运港",
    countryOfOrigin: "原产国",
    dnNo: "送货单号",
    currency: "币种",
    upcharge: "附加费",
    discountPct: "折扣 (%)",
    unknownCustomer: "（客户已不在列表中）",
    selectCustomer: "选择客户",
    selectContact: "选择联系人",
    selectPaymentCompany: "选择收款公司",
    paymentCompanyMissing: "尚未选择收款公司，打印的单据将没有汇款信息。",
    selectShippingMark: "选择唛头",
    selectRespBy: "选择负责人",
    noRespByOptions: "无法载入员工名单——请直接输入负责人。",
    respByFromStaff: "可创建或修改 PI、且能查看该客户所属公司的在职员工。在用户管理中新增人员、停用账号或更改权限后，名单会随之更新。",
    respByKept: "{{name}}（此 PI 已保存）",
    termsAutofilled: "由客户（买方）的付款条件自动带出",
    duplicatePo: "客户 PO“{{po}}”已用于 PI {{piNo}}。",
    addProducts: "新增产品",
    searchProducts: "以编号搜索产品",
    addToInvoice: "加入 PI",
    paymentNote: "备注",
  },
  analytics: {
    noData: "此期间没有数据。",
    region: "团队",
    regionHint: "分别查看各团队的销售。",
    orders: "订单数",
    summary: "总览",
    count: "计数",
    dimension: "分析维度",
    avgOrderValue: "平均订单金额",
    totalQuantity: "总数量",
    byRespBy: "依负责人营收",
    byProductType: "依产品类型营收",
    subtitle: "按产品、客户及月份分析销售",
    totalBilled: "PI 开票总额",
    productsSold: "已售产品",
    activeCustomers: "活跃客户",
    topProductsRevenue: "主要产品 · 营收",
    topCustomersRevenue: "主要客户 · 营收",
    revenueByMonth: "每月营收",
    errorLoad: "无法加载销售分析。",
  },
  insight: {
    from: "起始日",
    to: "结束日",
    reset: "重置",
    defaultPeriod: "默认：{{from}} – {{to}}",
    presetDay: "最近一天",
    presetWeek: "最近一周",
    presetMonth: "最近一月",
    presetsLabel: "快捷期间",
    presetHint: "以今天为止的滚动期间（越南时间）：最近一天 = 昨天和今天，最近一周 = 往前 7 天，最近一月 = 上月同一天起。日期会填入输入框，可清楚看到统计范围。",
    rangeReversed: "起始日晚于结束日",
  },
  profit: {
    subtitle: "PI 营收与产品成本 · 毛利",
    revenue: "营收",
    cost: "成本",
    costIncomplete: "缺成本",
    costIncompleteHint: "至少一行没有采购价也没有目录成本，以 0 计算 — 显示的毛利高于实际。",
    costIncompleteNotice: "{{count}} 张形式发票有未录入成本的明细，以 0 计算，因此上方毛利偏高。",
    totalQuantity: "已订 {{count}} 件",
    costFromPo: "{{withPo}}/{{total}} 张 PI 采用实际采购成本",
    grossMargin: "毛利",
    marginPercent: "毛利率 %",
    margin: "利润",
    errorLoad: "无法加载利润汇总。需要管理员或经理权限。",
  },
  invoices: {
    subtitle: "由形式发票一对一开立",
    invoiceNo: "发票编号",
    document: "发票",
    errorLoad: "无法加载发票列表。",
    notFound: "找不到发票。",
    fromPiSummary: "{{customer}} · 来自 PI {{pi}}",
    title: "发票",
    newInvoice: "新增发票",
    piNo: "PI 编号",
    selectPi: "选择形式发票",
    noAvailablePi: "没有尚未开立发票的形式发票。",
    piOption: "PI {{piNo}} · {{customer}} · {{currency}} {{amount}}",
    errorCreate: "无法创建发票。",
    errorSave: "无法保存发票。",
    copiedFromPi: "由形式发票复制",
    editInvoice: "编辑发票",
    editHint: "仅日期、买方联系人与客户 PO 可与 PI 不同，其余字段皆由 PI 复制。",
    changePi: "更换来源 PI",
    changePiWarning: "更换 PI 会由新的 PI 重新复制整份表头与所有明细。",
    searchPiHint: "以 PI 编号或客户 PO 搜索",
    numberAssigned: "保存时自动编号",
    confirmDelete: "删除发票 {{number}}？系统将归档此记录。",
    errorDelete: "无法删除发票。",
  },
  purchaseOrders: {
    subtitle: "供应商订单 · 依成本由 PI 创建",
    alreadyOnOrder: "此单已有 — 再次加入会新增一行。",
    alreadyOnOrderShort: "· 已加入",
    orderNo: "采购单号",
    errorLoad: "无法加载采购单。",
    expectedDelivery: "预计交期",
    new: "新增采购单",
    document: "采购单",
    orderDate: "下单日期",
    actualDelivery: "实际交期",
    paymentTerms: "付款条件",
    shippingMethod: "运输方式",
    supplierSection: "供应商信息",
    orderDetails: "订单明细",
    selectContact: "选择联系人",
    contactPerson: "联系人",
    linkPi: "关联形式发票",
    linkPiHint: "选择 PI 以按成本自动带入供应商与明细。",
    piAlreadyLinked: "PI {{number}} 已关联至采购单 {{po}}。",
    taxPercent: "税率 (%)",
    tax: "税额",
    addProduct: "新增产品",
    noItems: "尚未新增明细。",
    selectSupplierFirst: "请先选择供应商再新增产品。",
    supplierMismatch: "{{product}} 不属于 {{supplier}}。",
    supplierChangeClears: "更换供应商会清除目前的明细。",
    supplierRequired: "必须选择供应商。",
    itemsRequired: "至少需要一条明细。",
    expectedRequired: "必须填写预计交期。",
    loading: "正在加载采购单…",
    errorSave: "无法保存采购单。",
    confirmDelete: "删除采购单 {{number}}？将会归档。",
    notFound: "找不到采购单。",
    numberAssigned: "保存时自动编号",
    numberYearHint: "PO 编号中的年份取自开立日期，而非订单日期。",
    searchPi: "以 PI 编号或客户 PO 搜索",
    clearPi: "清除 PI",
    linkedPi: "已关联的 PI",
    createFromPi: "由此 PI 创建采购单",
    createFromPiHint: "明细会依供应商分组，为每家供应商各创建一张采购单，并以成本计价。",
    createdCount: "已创建 {{count}} 张采购单。",
    supplierReadOnly: "取自供应商信息",
    invalidTax: "请输入 0 至 100 之间的税率。",
    errorDelete: "无法删除采购单。",
  },
  packingLists: {
    subtitle: "箱件信息 · 由 PI 创建",
    listNo: "装箱单号",
    errorLoad: "无法加载装箱单。",
    piInvoice: "PI / 发票编号",
    shippingMode: "运输方式",
    weightKgs: "净重 / 毛重 (kg)",
    newPackingList: "新增装箱单",
    attention: "收件人",
    shippingMarks: "唛头",
    selectPi: "形式发票",
    selectPiHint: "以 PI 编号、发票编号、付款方或收货地址搜索",
    piLocked: "装箱单创建后不可更改 PI。",
    availableItems: "可装箱项目",
    originalQty: "原始数量",
    remainingQty: "剩余数量",
    depleted: "已装完",
    ctnNo: "箱号",
    shipTo: "送货地址",
    newCtn: "新增箱",
    removeCtn: "移除箱",
    addToCtn: "加入箱内",
    emptyCtn: "空箱 — 请于上方加入项目",
    netWeight: "净重 (kg)",
    grossWeight: "毛重 (kg)",
    measurement: "尺寸 (cm)",
    itemNo: "货号",
    subRef: "子参考",
    customerPo: "客户 PO",
    errorNoCtn: "保存前请至少创建一个箱。",
    errorEmptyCtn: "有 {{count}} 个空箱，请加入项目或移除。",
    errorOverQty: "可用数量上限为 {{max}}。",
    errorSave: "无法保存装箱单。",
    invoiceNo: "发票编号",
    selectCtn: "选择箱",
    available: "可用",
    packedQty: "已装",
    noCtns: "尚无箱件。",
    noPiSelected: "请先选择形式发票。",
    errorLoadPi: "无法加载形式发票。",
    confirmDelete: "删除装箱单 {{number}}？将会归档。",
    empty: "尚无装箱单。",
  },
  deliveryNotes: {
    sourceLockedHint: "创建后来源单据即固定 — 更换来源会清除已交数量。若选错来源，请删除此单并从正确单据重新创建。",
    shipTo: "送货地址",
    subtitle: "出货 · 来自装箱单或发票",
    noteNo: "送货单号",
    billTo: "付款方",
    errorLoad: "无法加载送货单。",
    deliveryDate: "交货日期",
    newDeliveryNote: "新增送货单",
    deliveryStatus: "交货状态",
    refType: "来源单据类型",
    fromPacking: "来自装箱单",
    fromInvoice: "来自发票",
    selectReference: "来源单据",
    deliveryMode: "交货方式",
    deliveryModeHint: "例如：货车、面包车、快递",
    vehicleNo: "车牌号",
    driverName: "司机姓名",
    driverPhone: "司机电话",
    itemNo: "货号",
    ctnNo: "箱号",
    subRef: "子参考",
    orderedQty: "订购数量",
    deliveredQty: "已交数量",
    lineRemarks: "行备注",
    errorNoReference: "请先选择装箱单或发票。",
    errorSave: "无法保存送货单。",
    confirmDelivery: "确认已交数量",
    created: "已创建送货单 {{number}}。",
    changeStatus: "变更交货状态",
    totalOrdered: "订购总数",
    totalDelivered: "已交总数",
    deliveredCap: "已交数量不可超过订购数量。",
    noItems: "此送货单没有项目。",
    errorCreate: "无法创建送货单。",
    confirmDelete: "删除送货单 {{number}}？将会归档。",
    empty: "尚无送货单。",
  },
  statement: {
    sheetSummary: "summary",
    sheetDetails: "details",
    sheetAging: "aging",
    agingAll: "账龄 · 目前查看的所有客户",
    expandAll: "全部展开",
    collapseAll: "全部收起",
    overdueDays: "逾期 {{count}} 天",
    bucket: "账龄区间",
    exportSheets: "导出 Excel（3 个表）",
    totalBilled: "已开立",
    totalPaid: "已收款",
    recovered: "回收率",
    outstanding: "未收",
    overdue: "逾期",
    overdueCount: "{{count}} 张单据",
    billedShort: "开立",
    paidShort: "已收",
    subtitle: "应收账款 · 按客户分析账龄",
    allCustomers: "所有客户",
    noBalances: "没有未结余额",
    allSettled: "所有发票均已结清。",
    errorLoad: "无法加载对账单。",
  },
  users: {
    subtitle: "账户与角色 · 服务器强制权限",
    newUser: "新增用户",
    createUser: "创建用户",
    user: "用户",
    errorCreate: "无法创建用户。",
    errorLoad: "无法加载用户列表。需要管理员权限。",
    editUser: "编辑用户",
    changeRole: "变更角色",
    confirmPassword: "确认密码",
    passwordMismatch: "两次输入的密码不一致。",
    you: "您",
    resetPassword: "重置密码",
    disableUser: "停用账户",
    enableUser: "启用账户",
    lastAdminProtected: "不可降级最后一位管理员。",
    selfDowngradeBlocked: "您不能降低自己的管理员权限，请由其他管理员操作。",
    confirmRoleChange: "要移除 {{email}} 的管理员权限吗？",
    errorUpdate: "无法更新用户。",
  },
  settings: {
    sectionsLabel: "设置分类",
    catalogTab: "目录",
    catalogTabHint: "产品字典",
    companyTab: "公司",
    companyTabHint: "公司信息与联系方式",
    outputTab: "输出",
    outputTabHint: "打印机与文件",
    masterDataEyebrow: "主数据",
    organisationEyebrow: "组织",
    outputEyebrow: "输出",
    catalogOptions: "目录选项",
    productTypes: "产品类型",
    productTypesDescription: "管理新增及编辑产品窗口中的类型下拉列表。此处的顺序亦是表单中的显示顺序。中文名称（选填）会显示在产品页面的英文名称下方。",
    productTypePlaceholder: "例如：金属按扣",
    productUnits: "产品单位",
    productUnitsDescription: "管理新增及编辑产品窗口中的单位下拉列表。现有目录使用中的单位会自动加入。",
    productUnitPlaceholder: "例如：gross",
    configuredCount: "已设置 {{count}} 项",
    addOption: "新增选项",
    optionLabelZh: "中文名称",
    optionExists: "此选项已存在。",
    moveUp: "向上移",
    moveDown: "向下移",
    removeOption: "移除选项",
    minimumOneOption: "至少需要保留一个选项",
    companyInformation: "公司信息",
    companyName: "公司名称",
    labelPrinter: "热敏标签打印机 (CT321D)",
    labelPreset: "预设标签尺寸",
    labelCustom: "自定义尺寸…",
    labelSizeInvalid: "标签尺寸无效（{{field}}），请使用 20–100 mm。",
    widthMm: "宽度 (mm)",
    heightMm: "高度 (mm)",
    labelRotate: "打印时将内容旋转 90°",
    errorLoad: "无法加载设置。",
    errorSave: "无法保存设置。",
    paymentTerms: "付款条件",
    paymentTermsDescription: "控制客户、采购单与形式发票上的付款条件下拉菜单。此处的排序即为表单中的显示顺序。",
    paymentTermsPlaceholder: "例如：After Statement 30 Days",
    shippingMethods: "运输方式",
    shippingMethodsDescription: "控制采购单上的运输方式下拉菜单。",
    poPriorities: "采购单优先级",
    poPrioritiesDescription: "控制采购单上的优先级下拉菜单。",
    paymentCompanies: "收款公司",
    paymentCompaniesDescription: "受益人与银行账户信息，印在每一张形式发票与发票上。",
    addCompany: "新增公司",
    defaultCompany: "默认",
    companyLogo: "打印文件上的标志",
    noLogo: "尚无标志 — 打印时使用默认 Hisense 标志",
    uploadLogo: "上传标志",
    beneficiary: "受益人",
    beneficiaryBank: "受益银行",
    bankAddress: "银行地址",
    swiftCode: "SWIFT 代码",
    accountNumberUsd: "美元账号",
    accountNumberHkd: "港币账号",
    accountNumberRmb: "人民币账号",
    setAsDefaultCompany: "设为默认公司",
    lastUpdated: "由 {{who}} 于 {{when}} 最后更新",
    counters: "单据编号计数",
    countersDescription: "仅供查看：各序列即将发出的下一个号码。",
    defaults: "新记录的默认值",
    defaultsDescription: "创建新产品时应用；既有记录不受影响。",
    defaultCurrency: "默认币种",
    defaultProductUnit: "默认产品单位",
    shippingMarks: "唛头",
    shippingMarksDescription: "形式发票表单上可选的预设唛头。",
    shippingMarkPlaceholder: "例如：N/M",
    weightUnits: "重量单位",
    weightUnitsDescription: "显示于每 100 件重量字段旁的单位。",
    weightUnitPlaceholder: "例如：kg",
    currencies: "币种列表",
    currencyPlaceholder: "例如 USD",
    shippingMethodPlaceholder: "例如 Sea Freight",
    poPriorityPlaceholder: "例如 Urgent",
    quotationPreparedByPlaceholder: "例如 Louis Chen",
    currenciesDescription: "控制所有销售与采购单据上的币种下拉菜单。",
    quotationPreparedBy: "报价单“制表人”选项",
    quotationPreparedByDescription: "控制报价单上的制表人下拉菜单。",
    labTestStandards: "检测标准",
    labTestStandardsDescription: "控制新增／编辑样品订单中“检测要求”下拉菜单。此处的排序即为表单中的显示顺序。",
    supplierSpecializations: "供应商专长",
    supplierSpecializationsDescription: "控制供应商联系人的专长下拉菜单。此处的排序即为表单中的显示顺序。",
    supplierSpecializationPlaceholder: "例如：Plastic Stopper",
  },
  archive: {
    searchPlaceholder: "搜索单号、客户 PO、删除者…",
    allTypes: "所有类型",
    documentNo: "单号",
    party: "对象",
    viewSnapshot: "查看原始数据",
    notRestorable: "仅留审计记录",
    notRestorableHint: "此数据表为永久删除；归档保留副本供审计，但无法还原记录。",
    confirmRestore: "还原这条记录？它会重新出现在列表与报表中。",
    snapshotTitle: "已删除记录的原始数据",
    snapshotRedacted: "依您的权限，供应商成本与供应商信息已隐藏。",
    errorRestore: "无法还原此记录。",
    restoreProductTitle: "以新的编号或子参考还原",
    restoreProductHint: "为已删除的产品输入其他编号或子参考，然后还原。正在使用原组合的产品保持不变。",
    openConflictingProduct: "打开正在使用此组合的产品（新标签页）",
    subtitle: "审计归档 · 还原已删除记录",
    empty: "归档目前为空",
    emptyHint: "已删除的记录会显示于此以供还原。",
    errorLoad: "无法加载归档。需要管理员权限。",
  },
  resourceTypes: {
    piAttachments: "订单凭证文件（PI）",
    pProcessAttachments: "P 流程图片",
    customerRequirements: "客户产品要求",
    customerRequirementPhotos: "客户要求照片",
    routings: "工艺路线",
    customers: "客户",
    suppliers: "供应商",
    products: "产品",
    proformaInvoices: "形式发票",
    invoices: "发票",
    quotations: "报价单",
    purchaseOrders: "采购单",
    packingLists: "装箱单",
    deliveryNotes: "送货单",
    sampleOrders: "样品订单",
    sampleCards: "样品卡",
    boms: "物料清单",
    salesOrders: "销售订单",
    purchaseRequisitions: "采购申请单",
    warehouses: "仓库",
    warehouseBins: "库位",
    stockMoves: "库存变动",
    productionResources: "生产资源",
    workOrders: "工单",
    inspections: "检验单",
    glAccounts: "总账科目",
    journalEntries: "分录",
    serviceTickets: "服务单",
    qualitySpecs: "质量规格",
    mrpRuns: "MRP 方案",
    unitProfiles: "单位设置",
    piPayments: "PI 付款",
    salesOpportunities: "销售机会",
    serviceCases: "售后案件",
    sourcingCases: "询价单（RFQ）",
    subcontractOrders: "委外工单",
  },
  comingSoon: {
    title: "功能开发中",
    description: "此功能正在开发中，将于近期推出。感谢您的耐心等候。",
    backToOverview: "返回总览",
  },
  status: {
    paid: "已付款",
    partial: "部分付款",
    unpaid: "未付款",
    approved: "已审核",
    pending: "待处理",
    underReview: "审核中",
    rejected: "已拒绝",
    draft: "草稿",
    active: "启用",
    inactive: "停用",
    disabled: "已停用",
    obsolete: "已作废",
    confirmed: "已确认",
    sent: "已发送",
    delivered: "已交付",
    partiallyDelivered: "部分交付",
    inTransit: "运送中",
    received: "已接收",
    testing: "测试中",
    completed: "已完成",
    inProduction: "生产中",
    shipped: "已出货",
    closed: "已关闭",
    cancelled: "已取消",
    ordered: "已订购",
    in: "入库",
    out: "出库",
    transfer: "调拨",
    adjust: "调整",
    planned: "已计划",
    released: "已下达",
    inProgress: "进行中",
    done: "已完成",
    pass: "合格",
    fail: "不合格",
    incoming: "来料",
    inProcess: "制程",
    final: "最终",
    asset: "资产",
    liability: "负债",
    equity: "权益",
    revenue: "收入",
    expense: "费用",
    low: "低",
    medium: "中",
    high: "高",
    urgent: "紧急",
    open: "打开",
    resolved: "已解决",
    current: "当前",
    paymentProgress: "{{status}} — {{percent}}%",
  },
  roles: {
    admin: "管理员",
    manager: "经理",
    accountant: "会计",
    viewer: "查看者",
  },
  account: {
    security: "安全",
    changePassword: "修改密码",
    currentPassword: "当前密码",
    newPassword: "新密码",
    confirmPassword: "再次输入新密码",
    passwordHint: "至少 8 个字符。",
    passwordMismatch: "两次输入的新密码不一致。",
    passwordChanged: "密码已修改，下次登录起生效。",
    errorChangePassword: "无法修改密码。",
    // Chân thanh bên (19/09/2026): tài khoản chọn từng màn hình không hiện vai trò gốc — "Người xem" dưới tên nhân viên mua hàng là sai.
    customAccess: "自定义权限",
  },
  label: {
    printer: "标签打印机",
    print: "打印标签",
    count: "标签张数",
    qty: "样品数量",
    qtyHint: "选填 — 覆盖标签上打印的数量。",
    dialogHint: "按“打印”会打开电脑的打印对话框——请在其中选择标签打印机。该打印机必须已安装于这台电脑；若未安装，列表中不会出现，标签会由普通打印机打印。",
    sizeInUse: "标签尺寸 {{w}} × {{h}} mm，取自设置。",
    error: {
      badSize: "设置中的标签尺寸无效（{{field}}），请先修正再打印。",
    },
  },
  errors: {
    supplierRegion: "此账号只能处理本区域的供应商。如需新建或调整该供应商，请联系管理员。",
    followerInvalid: "跟单员必须是在职员工账号（不能是已停用账号或供应商门户账号）。",
    followerRegion: "该跟单员无法查看此区域的客户。请在权限中调整其数据区域，或选择其他人。",
    privateAdminOnly: "只有管理员能更改私密设置或可查看人员名单。",
    privateSupplier: "此单据使用了您无权查看的私密供应商。只有管理员和该供应商的跟进人可以修改。",
    unauthorized: "登录会话已超时，请重新登录。",
    readOnly: "您仅有此记录的查看权限 — 字段已被锁定，并非故障。",
    forbidden: "您没有权限执行此操作。",
    customerTerms: "您没有权限修改此客户的付款条款或订单要求（权限中的“付款条款与订单要求”）。",
    validation: "部分数据无效，请检查表单后再试一次。",
    notFound: "此记录已不存在或无法使用。",
    emailTaken: "此电子邮件地址已被使用。",
    invoiceExists: "此形式发票已创建发票。",
    currencyMismatch: "价格币种必须与产品币种相同。",
    notRestorable: "无法还原此归档记录。",
    noFile: "请选择要上传的图片。",
    badImageType: "仅支持 PNG、JPEG、WEBP 或 GIF 图片。",
    imageTooLarge: "图片大小不得超过 5 MB。",
    companyTaken: "已存在使用此公司名称的客户。",
    supplierCompanyTaken: "同一区域（或未分类）已有同名供应商。",
    portalLoginIdTaken: "此登录代码已被其他供应商使用。每家供应商必须拥有各自的代码。",
    portalLoginIdFormat: "登录代码为 3–40 个字符：字母、数字、连字符或下划线；不可有空格或 @。",
    portalAccountExists: "此供应商已有门户账号。",
    portalAccountMissing: "此供应商尚未有门户账号。",
    originalRowMissing: "原始记录已不在系统中，仅存归档数据，无法还原；归档数据已保留。",
    customerRequired: "请选择客户（Bill To）。",
    customerRegion: "此账号只能处理本区域的客户。如需新建或转移该客户，请联系管理员。",
    paymentCompanyRequired: "请选择收款公司。",
    itemsRequired: "请至少新增一个品项。",
    forbiddenTitle: "您没有此页面的访问权限",
    forbiddenBody: "您的账号未获授权查看此页面，如有需要请联系管理员。",
    forbiddenGoHome: "回到我的首页",
    productCodeExhausted: "无法分配未使用的产品编号，请手动输入。",
    piAlreadyLinked: "此形式发票已关联至一张采购单。",
    supplierMismatch: "有明细不属于所选的供应商。",
    duplicateCtnNo: "箱号不可重复。",
    overPacked: "装箱数量超过形式发票行的数量。",
    unknownLine: "有项目不属于此送货单。",
  },
  print: {
    code: "编号",
    description: "说明",
    colorSize: "颜色 / 尺寸",
    qty: "数量",
    unitPrice: "单价",
    amount: "金额",
    subtotal: "小计",
    upcharge: "附加费",
    less: "折扣 ({{pct}}%)",
    grandTotal: "总计",
    total: "总计",
    remarks: "备注",
    generated: "生成于 {{date}}",
  },
  erpResource: {
    errorLoad: "无法加载此模块。",
    errorCreate: "无法创建记录。",
    subtitles: {
      boms: "物料清单 · 多层标准用量",
      salesOrders: "端到端销售订单 · 信用控制",
      requisitions: "采购申请 · MRP 需求",
      warehouses: "存储位置",
      stockMoves: "入库 / 出库 / 调拨 / 调整",
      workOrders: "生产工单 · 产出",
      inspections: "来料 / 制程 / 最终质量检验",
      glAccounts: "会计科目表",
      journalEntries: "日记账 · 业务与财务整合",
      serviceTickets: "售后服务与 RMA",
    },
    fields: {
      product: "产品",
      productCode: "产品编号",
      version: "版本",
      status: "状态",
      soNo: "销售单号",
      orderDate: "订单日期",
      total: "总计",
      customer: "客户",
      remarks: "备注",
      prNo: "申请单号",
      neededBy: "需求日期",
      code: "编号",
      name: "名称",
      location: "位置",
      moveNo: "库存变动单号",
      type: "类型",
      qty: "数量",
      when: "时间",
      quantity: "数量",
      reference: "参考",
      woNo: "工单号",
      planned: "计划",
      produced: "已生产",
      description: "说明",
      plannedQty: "计划数量",
      dueDate: "到期日",
      qcNo: "质检单号",
      result: "结果",
      rejected: "不合格",
      referencePoWo: "参考 (PO/WO)",
      qtyInspected: "检验数量",
      qtyRejected: "不合格数量",
      notes: "备注",
      accountType: "类型",
      jeNo: "日记账编号",
      date: "日期",
      memo: "摘要",
      debit: "借",
      credit: "贷",
      amount: "金额",
      debitAccount: "借方科目",
      creditAccount: "贷方科目",
      sourceRef: "来源参考",
      ticket: "案件号",
      subject: "主题",
      priority: "优先级",
      supplier: "供应商",
    },
  },
};
